import { Data } from 'signup-constants/signupData/Data';
import { DataOptions } from '../signup-data/signupDataOptions';
import { BaseButtonsView } from './BaseButtonsView';
import { useSignupData } from '../signup-data/useSignupData';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { getLayoutColumnCount } from '../utils/getLayoutColumnCount';
import { jsx as _jsx } from "react/jsx-runtime";
const UserSizeView = () => {
  const {
    data: companySize
  } = useSignupData(Data.CompanySize);
  const options = DataOptions[Data.UserSize](companySize);
  const {
    isMobile
  } = useResponsiveness();
  const columnCount = getLayoutColumnCount(options.length, isMobile);
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    columnCount: columnCount,
    options: options,
    shouldCenterLastRow: false,
    shouldDisableAutofocus: true
  });
};
export default UserSizeView;